import React from 'react'

export function Contabilidad() {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="18.704" height="26.186" viewBox="0 0 18.704 26.186">
  <g transform="translate(-96 -32)">
    <path d="M-13.194-16H-.1A2.809,2.809,0,0,1,2.7-13.194V7.381A2.809,2.809,0,0,1-.1,10.186H-13.194A2.809,2.809,0,0,1-16,7.381V-13.194A2.809,2.809,0,0,1-13.194-16ZM-.1,8.316a.936.936,0,0,0,.935-.935V-13.194A.936.936,0,0,0-.1-14.13H-13.194a.936.936,0,0,0-.935.935V7.381a.936.936,0,0,0,.935.935Z" transform="translate(112 48)" fill="#060606"/>
    <path id="Rectángulo_809" data-name="Rectángulo 809" d="M-15.037-16H-3.482a.92.92,0,0,1,.963.87v3.482a.92.92,0,0,1-.963.87H-15.037a.92.92,0,0,1-.963-.87V-15.13A.92.92,0,0,1-15.037-16Zm10.592,1.741h-9.629v1.741h9.629Z" transform="translate(114.612 51.482)" fill="#060606"/>
    <circle cx="1.317" cy="1.317" r="1.317" transform="translate(98.866 43.419)" fill="#060606"/>
    <circle cx="1.317" cy="1.317" r="1.317" transform="translate(103.881 43.419)" fill="#060606"/>
    <ellipse cx="1.647" cy="1.317" rx="1.647" ry="1.317" transform="translate(109.152 43.419)" fill="#060606"/>
    <circle cx="1.317" cy="1.317" r="1.317" transform="translate(98.866 47.701)" fill="#060606"/>
    <circle cx="1.317" cy="1.317" r="1.317" transform="translate(103.881 47.701)" fill="#060606"/>
    <circle cx="1.317" cy="1.317" r="1.317" transform="translate(98.866 52.917)" fill="#060606"/>
    <circle cx="1.317" cy="1.317" r="1.317" transform="translate(103.881 52.917)" fill="#060606"/>
    <rect width="3.294" height="7.246" rx="1.647" transform="translate(109.152 48.306)" fill="#707070"/>
  </g>
</svg>
 
  )
}
